import { useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import classNames from "classnames";
import styles from "./style.module.scss";
import CustomInput from "shared/components/common/customInput";
import CustomButton from "shared/components/common/customButton";
import { UpdatePasswordService } from "shared/services/settings";
import { toastMessage } from "shared/components/common/toast";
import { handleErrors } from "shared/utils/helper";

const ChangePassword = () => {
  const [loading, setLoading] = useState<boolean>(false);

  const validationSchema = Yup.object({
    currentPassword: Yup.string().required("Current password is required"),
    newPassword: Yup.string().required("New password is required"),
    confirmPassword: Yup.string()
      // @ts-ignore
      .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
      .required("Confirm password is required"),
  });

  const formik = useFormik({
    initialValues: {
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        await UpdatePasswordService(
          values.currentPassword,
          values.newPassword
        );
        toastMessage("success", "Password updated successfully");
        formik.resetForm();
      } catch (error) {
        handleErrors(error);
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <div>
      <h1 className="font-medium">Update Password</h1>
      <div className={classNames(styles.sectionContainer, "my-4")}>
        <form
          onSubmit={formik.handleSubmit}
          className={classNames(styles.body)}
        >
          <CustomInput
            label="Current Password"
            placeholder="Enter Current Password"
            name="currentPassword"
            isPassword
            type="password"
            value={formik.values.currentPassword}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.currentPassword && formik.errors.currentPassword
                ? formik.errors.currentPassword
                : ""
            }
          />

          <CustomInput
            label="New Password"
            placeholder="Enter New Password"
            name="newPassword"
            isPassword
            type="password"
            value={formik.values.newPassword}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.newPassword && formik.errors.newPassword
                ? formik.errors.newPassword
                : ""
            }
          />

          <CustomInput
            label="Confirm Password"
            placeholder="Confirm New Password"
            name="confirmPassword"
            isPassword
            type="password"
            value={formik.values.confirmPassword}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.confirmPassword && formik.errors.confirmPassword
                ? formik.errors.confirmPassword
                : ""
            }
          />

          <div className="flex justify-end mt-3">
            <CustomButton loading={loading} type="submit" title="Update" />
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;
